export function emptyQuiz() {
  return {
    title: '', description: '', category: '', is_published: false,
    show_score: true, show_pass_fail: false, passing_score: 80, review_mode: 'all',
    questions: [],
  };
}

export function emptyQuestion(type = 'single') {
  const base = { type, prompt: '', explanation: '', position: 0, points: 1, options: [] };
  if (type === 'true_false') {
    base.options = [
      { text: 'True', is_correct: false, position: 0 },
      { text: 'False', is_correct: false, position: 1 },
    ];
  } else {
    base.options = [
      { text: '', is_correct: false, position: 0 },
      { text: '', is_correct: false, position: 1 },
    ];
  }
  return base;
}

export function setCorrect(question, optionIndex, checked) {
  const single = question.type === 'single' || question.type === 'true_false';
  const options = question.options.map((o, i) => ({
    ...o,
    is_correct: i === optionIndex ? checked : (single ? false : o.is_correct),
  }));
  return { ...question, options };
}

export function narrowCorrectForType(question, newType) {
  if (newType !== 'single' && newType !== 'true_false') {
    return { ...question, type: newType, options: question.options.map((o) => ({ ...o })) };
  }
  const correctCount = question.options.filter((o) => o.is_correct).length;
  if (correctCount <= 1) {
    return { ...question, type: newType, options: question.options.map((o) => ({ ...o })) };
  }
  let keptFirst = false;
  const options = question.options.map((o) => {
    if (o.is_correct && !keptFirst) {
      keptFirst = true;
      return { ...o, is_correct: true };
    }
    return { ...o, is_correct: false };
  });
  return { ...question, type: newType, options };
}

export function normalizePositions(quiz) {
  return {
    ...quiz,
    questions: quiz.questions.map((q, qi) => ({
      ...q,
      position: qi,
      options: q.options.map((o, oi) => ({ ...o, position: oi })),
    })),
  };
}
